module.exports = __webpack_public_path__ + "../static/img/essay.1134d28b.jpg";